function Share(){
    return (
        <>
            <section id="share" className="share">
                <div className="share-layout">
                    <div className="share-desc">
                        <div className="sl">Share</div>

                        <div className="st">
                            Show your numbers.<br />
                            Start the conversation.
                        </div>

                        <p>
                            Generate a beautiful one-page usage summary directly from the app. Easy to screenshot,
                            share to WhatsApp, or post anywhere you like.
                        </p>

                        <div className="share-tags">
                            <div className="tag">📲 WhatsApp</div>
                            <div className="tag">🐦 Twitter / X</div>
                            <div className="tag">📸 Instagram</div>
                            <div className="tag">📄 Download PDF</div>
                        </div>
                    </div>

                    <div className="share-card">
                        <div className="share-card-header">
                            <div className="share-avatar">🏠</div>

                            <div>
                                <div className="share-name">Bolu's Usage Summary</div>
                                <div className="share-sub">Sabo Yaba · 5th April, 2025 - 10th April, 2025</div>
                            </div>

                            <div
                                style={{
                                    marginLeft: "auto",
                                    fontSize: ".7rem",
                                    color: "rgba(232,234,246,.35)",
                                    fontStyle: "italic",
                                }}
                            >
                                via Inaread
                            </div>
                        </div>

                        <div className="share-nums">
                            <div className="sn">
                                <div className="v" style={{ color: "#86efac" }}>148 kWh</div>
                                <div className="l">Total used</div>
                            </div>

                            <div className="sn">
                                <div className="v" style={{ color: "#FF9E40" }}>₦9,620</div>
                                <div className="l">Est. cost</div>
                            </div>

                            <div className="sn">
                                <div className="v" style={{ color: "#93c5fd" }}>5 days</div>
                                <div className="l">Usage Period</div>
                            </div>

                            <div className="sn">
                                <div className="v" style={{ color: "#86efac" }}>↓ 14%</div>
                                <div className="l">vs last month</div>
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: ".65rem" }}>
                            <a
                                href="#download"
                                className="dl-btn dl-btn-fill"
                                style={{
                                    flex: 1,
                                    justifyContent: "center",
                                    borderRadius: "10px",
                                }}
                            >
                                <span style={{ fontSize: "1rem" }}>📲</span>
                                <span style={{ fontWeight: 600, fontSize: ".9rem" }}>
            Get the app to share
          </span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Share;
